import { Radio } from '@mui/material';
import { FormikProps, useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { SavedViewDraft } from '../../interfaces/ISavedView';
import SavedViewStore from '../../store/SavedViewStore';
import SavedViewSelectInput from '../inputs/SavedViewSelectInput';
import savedViewsStyles from "./SavedViews.module.css";

function SavedViewsUpdate({ savedViewStore, isActive, onSelect, onActiveFormik, onDone }: ISavedViewsUpdateProps) {
    const initialValues = useMemo(() => SavedViewDraft.empty(), []);

    const formik = useFormik<SavedViewDraft>({
        initialValues,
        onSubmit: async (values, helpers) => {
            const target = savedViewStore.savedViews.find((v: any) => v.name === values.name);
            if (!target) {
                helpers.setFieldError('name', 'Select existing view');
                return;
            }
            await savedViewStore.updateSavedView({ ...values, id: target.id, name: target.name });
            toast.success("Successfully!");
            onDone();
        },
    });

    useEffect(() => {
        if (!isActive) {
            formik.resetForm({ values: SavedViewDraft.empty() });
            return;
        }
    }, [isActive]);

    useEffect(() => {
        if (!isActive) return;
        onActiveFormik({ ...formik, values: formik.values });
    }, [isActive, formik.values])

    return (
        <div className={savedViewsStyles.savedViewOption} onClick={onSelect}>
            <Radio checked={isActive} onChange={onSelect} />
            <div className={savedViewsStyles.savedViewOptionContent}>
                <div className={savedViewsStyles.savedViewOptionTitle}></div>

                <div style={!isActive ? { pointerEvents: 'none', opacity: 0.6 } : undefined}>
                    <SavedViewSelectInput
                        formik={formik}
                        label="UPDATE VIEW"
                        placeholder="Search views..."
                    />
                </div>
            </div>
        </div>
    );
}

export default observer(SavedViewsUpdate);

interface ISavedViewsUpdateProps {
    savedViewStore: SavedViewStore;
    isActive: boolean;
    onSelect: () => void;
    onActiveFormik: (formik: FormikProps<SavedViewDraft> | null) => void;
    onDone: () => void;
}
